import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const ArrowRight: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 24, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <path fillRule="evenodd" clipRule="evenodd" d="M8.87868 18.7071C8.48816 18.3166 8.48816 17.6834 8.87868 17.2929L14.1716 12L8.87868 6.70711C8.48816 6.31658 8.48816 5.68342 8.87868 5.29289C9.2692 4.90237 9.90237 4.90237 10.2929 5.29289L17 12L10.2929 18.7071C9.90237 19.0976 9.2692 19.0976 8.87868 18.7071Z" fill={color} />
</svg>);
export default ArrowRight;